import { ElitetutorCreditEventType } from 'logic/api-models/api-models';

export enum EarningsTypePreset {
  EARNINGS = 'earnings',
  PAYOUTS = 'payouts',
}

/**
 * Credit event types requested per tab. Sent to the API as a `type` filter so
 * pagination stays correct and tutors can reach every payout receipt.
 *
 * An empty list means no filter, so the earnings tab keeps showing the full
 * history: it stays a no-op against the previous behaviour, it explains the
 * current balance in full (a payout is what makes it drop), and new event types
 * only need a render case on the page instead of an entry here.
 */
export const EARNINGS_PRESET_EVENT_TYPES: Record<EarningsTypePreset, ElitetutorCreditEventType[]> = {
  [EarningsTypePreset.EARNINGS]: [],
  [EarningsTypePreset.PAYOUTS]: [ElitetutorCreditEventType.payout],
};
